import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
	path: '/',
	redirect: {
		name: 'index'
	},
	component: layoutHeaderAside,
	children: [
		// 首页
		{
			path: 'index',
			name: 'index',
			meta: {
				auth: true
			},
			component: _import('system/index')
		},
		// 我的页面
		{
			path: 'UserInfo',
			name: 'UserInfo',
			meta: {
				title: '用户及权限',
				auth: true
			},
			component: _import('pages/UserInfo/UserInfo')
		},{
			path: 'UpdateLog',
			name: 'UpdateLog',
			meta: {
				title: '更新日志',
				auth: true
			},
			component: _import('pages/UpdateLog/UpdateLog')
		},{
			path: 'MenuInfo',
			name: 'MenuInfo',
			meta: {
				title: '系统菜单设置',
				auth: true
			},
			component: _import('pages/MenuInfo/MenuInfo')
		},{
			path: 'WorkInfo',
			name: 'WorkInfo',
			meta: {
				title: '打工素材查询',
				auth: true
			},
			component: _import('pages/WorkInfo/WorkInfo')
		},
		 {
			path: 'CgInfo',
			name: 'CgInfo',
			meta: {
				title: '采购入库',
				auth: true,
				cache: true
			},
			component: _import('pages/caigou/CgInfo'),
			props: route => ({ query: route.query.lx })
		}, 
		{
			path: 'CtInfo',
			name: 'CtInfo',
			meta: {
				title: '采购退出',
				auth: true,
				cache: true
			},
			component: _import('pages/caigou/CtInfo'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'ShenTui',
			name: 'ShenTui',
			meta: {
				title: '审核采退',
				auth: true,
				cache: true
			},
			component: _import('pages/caigou/ShenTui'),
			props: route => ({ query: route.query.lx })
		},{
			path: 'ShenCai',
			name: 'ShenCai',
			meta: {
				title: '审核采购',
				auth: true,
				cache: true
			},
			component: _import('pages/caigou/ShenCai'),
			props: route => ({ query: route.query.lx })
		},{
			path: 'Ruku',
			name: 'Ruku',
			meta: {
				title: '入库上架',
				auth: true,
				cache: true
			},
			component: _import('pages/caigou/Ruku'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'Tuichu',
			name: 'Tuichu',
			meta: {
				title: '购退出库',
				auth: true,
				cache: true
			},
			component: _import('pages/caigou/Tuichu'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'XsInfo',
			name: 'XsInfo',
			meta: {
				title: '销售出库',
				auth: true,
				cache: true
			},
			component: _import('pages/xiaoshou/XsInfo'),
			props: route => ({ query: route.query.lx })
		},{
			path: 'XtInfo',
			name: 'XtInfo',
			meta: {
				title: '销后退回',
				auth: true,
				cache: true
			},
			component: _import('pages/xiaoshou/XtInfo'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'ShenSh',
			name: 'ShenSh',
			meta: {
				title: '审核销售',
				auth: true,
				cache: true
			},
			component: _import('pages/xiaoshou/ShenSh'),
			props: route => ({ query: route.query.lx })
		},{
			path: 'ShenTh',
			name: 'ShenTh',
			meta: {
				title: '审核销退',
				auth: true,
				cache: true
			},
			component: _import('pages/xiaoshou/ShenTh'),
			props: route => ({ query: route.query.lx })
		},{
			path: 'Chuku',
			name: 'Chuku',
			meta: {
				title: '出库复核',
				auth: true,
				cache: true
			},
			component: _import('pages/xiaoshou/Chuku'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'Tuiru',
			name: 'Tuiru',
			meta: {
				title: '销退入库',
				auth: true,
				cache: true
			},
			component: _import('pages/xiaoshou/Tuiru'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'Kucun',
			name: 'Kucun',
			meta: {
				title: '库存查询',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/Kucun'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'Jctj',
			name: 'Jctj',
			meta: {
				title: '交叉统计',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/Jctj'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'aytj',
			name: 'aytj',
			meta: {
				title: '销售统计',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/aytj'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'HwInfo',
			name: 'HwInfo',
			meta: {
				title: '货位设置',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/HwInfo'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'Xuqiu',
			name: 'Xuqiu',
			meta: {
				title: '需求查询',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/Xuqiu'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'Chaxun',
			name: 'Chaxun',
			meta: {
				title: '出入查询',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/Chaxun'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'Zhuanyi',
			name: 'Zhuanyi',
			meta: {
				title: '货位转移',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/Zhuanyi'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'SpInfo',
			name: 'SpInfo',
			meta: {
				title: '产品录入',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/SpInfo'),
			//props: route => ({ query: route.query.lx })
		},{
			path: 'DwInfo',
			name: 'DwInfo',
			meta: {
				title: '产品录入',
				auth: true,
				cache: true
			},
			component: _import('pages/qita/DwInfo'),
			//props: route => ({ query: route.query.lx })
		},



		// 系统 前端日志
		{
			path: 'log',
			name: 'log',
			meta: {
				title: '前端日志',
				auth: true
			},
			component: _import('system/log')
		},
		// 刷新页面 必须保留
		{
			path: 'refresh',
			name: 'refresh',
			hidden: true,
			component: _import('system/function/refresh')
		},
		// 页面重定向 必须保留
		{
			path: 'redirect/:route*',
			name: 'redirect',
			hidden: true,
			component: _import('system/function/redirect')
		}
	]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	}
]

/**
 * 错误页面
 */
const errorPage = [{
	path: '*',
	name: '404',
	component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]
